import React, { FunctionComponent } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Gallery } from 'common/gallery/Gallery';
import { OnMediaClickFunc } from 'common/gallery/gallery-preview/GalleryPreview';
import { MediaType } from 'common/upload/Upload';
import { MediaPathsToAltText } from 'social/publisher/Publisher.types';

import 'social/common/collage/Collage.scss';

export interface Props {
    galleryData: any[];
    maxCount?: number;
    modalTitle?: string;
    openModalOnMediaClick?: boolean;
    onMediaClick?: OnMediaClickFunc;
    mediaPathsToAltText?: MediaPathsToAltText;
}

export interface CollageGallery {
    type: MediaType;
    name?: string;
    url: string;
}

export const Collage: FunctionComponent<Props> = ({
    galleryData,
    maxCount,
    modalTitle,
    openModalOnMediaClick,
    onMediaClick,
    mediaPathsToAltText,
}) => {
    const { t } = useTranslation(['social/publisher']);
    const isGalleryAtMax = (maxCount && galleryData.length >= maxCount) || false;
    const galleryModalTitle = modalTitle || t('Preview');
    const containerClass = classnames(
        `r4e-social-collage r4e-social-collage-count-${galleryData.length} r4e-social-collage-max-${maxCount}`,
        {
            'r4e-social-collage-max': isGalleryAtMax,
            'disable-hover': !openModalOnMediaClick,
        },
    );

    return (
        <div className={containerClass}>
            <Gallery
                height="100%"
                width="100%"
                galleryData={galleryData}
                modalTitle={galleryModalTitle}
                maxCount={maxCount}
                canDelete={false}
                modalSize="xl"
                displayFileNameOnHover={false}
                openModalOnHandleIconClick={false}
                openModalOnMediaClick={openModalOnMediaClick}
                onMediaClick={onMediaClick}
                mediaPathsToAltText={mediaPathsToAltText}
            />
        </div>
    );
};

Collage.defaultProps = {
    maxCount: 3,
    openModalOnMediaClick: true,
};
